// From~To 입력 검증 — 자리비움(시간)·출장/휴가(날짜) 공용.
// 날짜 'YYYY-MM-DD', 시간 'HH:mm' 은 사전식 문자열 비교로 대소 판단 가능.

/** 날짜 범위 검증 — 오류 메시지 또는 null */
export function dateRangeError(start: string, end: string): string | null {
  if (!start || !end) return '시작일·종료일을 모두 입력하세요.';
  if (end < start) return '종료일이 시작일보다 빠를 수 없습니다.';
  return null;
}

/** 시간 범위 검증(동일 일자) — 오류 메시지 또는 null */
export function timeRangeError(start: string, end: string): string | null {
  if (!start || !end) return '시작·종료 시간을 모두 입력하세요.';
  if (end <= start) return '종료 시간이 시작 시간보다 늦어야 합니다.';
  return null;
}
